export default __webpack_public_path__ + "static/media/606.230f4d30.gif";